const contentSelectorsByApp: Record<string, string> = {
  fandomdesktop: ".mw-parser-output",
  fandommobile: ".mw-parser-output",
  default: "#content",
};

export function getContentSelector(app?: string): string {
  return app
    ? (contentSelectorsByApp[app] ?? contentSelectorsByApp.default)
    : contentSelectorsByApp.default;
}
